import { Routes } from '@angular/router';

import { advaniaServicesSegments } from '@advania-cosoftware/wolf-router';

export const securityIntrusionDetectionAndResponseRoutes: Routes = [
    {
        path: advaniaServicesSegments.securityIntrusionDetectionAndResponse,
        loadComponent: () =>
            import('./pages/security-intrusion-detection-and-response-page/security-intrusion-detection-and-response.page').then(
                (m) => m.SecurityIntrusionDetectionAndResponsePage,
            ),
    },
];
